import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import heroImage400 from "@/assets/hero-bg-400w-new.jpg";
import heroImage800 from "@/assets/hero-bg-800w-new.jpg";
import heroImage1200 from "@/assets/hero-bg-1200w-new.jpg";
import heroImage1920 from "@/assets/hero-bg-1920w-new.jpg";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-background py-20 md:py-32">
      <div className="absolute inset-0 opacity-5" role="presentation">
        <img
          srcSet={`${heroImage400} 400w, ${heroImage800} 800w, ${heroImage1200} 1200w, ${heroImage1920} 1920w`}
          sizes="100vw"
          src={heroImage1920}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className="container relative mx-auto px-6">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="mb-4 text-4xl font-bold leading-tight text-foreground md:text-6xl flex flex-col items-center justify-center">
            <span className="block">FM &amp; Public Sector Staffing.</span>
            <span className="block bg-gradient-hero bg-clip-text text-transparent pb-1">
              Nationwide. Fast.
            </span>
          </h1>

          <p className="mb-8 text-lg text-muted-foreground md:text-xl leading-relaxed max-w-3xl mx-auto">
            We supply DBS-cleared, PAYE-compliant workers to government, justice, education and housing clients across the UK, typically within 24–48 hours of requisition.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/employers">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground px-8">
                Find Workers
              </Button>
            </Link>
            <Link to="/jobs">
              <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary/10 px-8">
                Find Work
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
